export default __webpack_public_path__ + "static/media/team.f3b7f1d9.svg";